import { Card, Typography, Tabs, Button, Switch } from "antd";
import { useTranslation } from "../../context/TranslationContext";
import OrderListDetail from "./OrderListDetail";
import BulkUploadModal from "./OrderListDetail/BulkUploadModal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import globalRequest from "../../utils/global/globalRequest";
import * as Apis from "../../utils/helper/enum";
import toast from "react-hot-toast";
import { addDeleteGetLocalStorage, storageKeys } from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";
import { useOrderManagment } from "../../Hooks/orderManagement/useOrderManagment";
import { timeSlots } from "../../utils/helper/constants";
import { useLocation, useSearchParams } from "react-router-dom";
import { checkPermissionAction } from "../../utils/helper/utils";

const OrderManagement = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [defaultTabIndex, setDefaultTabIndex] = useState("1");
  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  const [allCounts, setAllCounts] = useState([]);
  const [inputData, setInputData] = useState({});
  const { t, changeLocale, locale } = useTranslation();

  const handleLanguageChange = async (checked) => {
    const newLang = checked ? "ar" : "en";
    changeLocale(newLang);
    try {
      await globalRequest(
        Apis?.ORDERS?.SET_PREFERRED_LANGUAGE,
        "post",
        { lang: newLang },
        {},
        true
      );
    } catch (error) {
      toast.error(error?.message || "Failed to update language preference");
    }
  };

  const onTabChange = (key) => {
    setDefaultTabIndex(key);
  };

  const userAccess = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }

  const getAllOrdersCount = async (countApiFilter) => {
    dispatch(changeLoader(true));

    try {
      let params = countApiFilter;
      let response = await globalRequest(Apis.ORDERS.ORDER_STATUS_COUNT, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setAllCounts(apiResponse.data);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const [filter, setFilter] = useState({
    startdate: null,
    enddate: null,
    timeSlot: [],
    orderType: [],
    status: [],
    branch: [],
    zone: [],
    vendor: [],
    driver: [],
  });

  const { getAllBranch, getAllZone, getAllVendor, getAllDriver, getAllDropzone, allBranch, allZone, allVendor, allDriver, allDropzone } =
    useOrderManagment();
  useEffect(() => {
    const fetchData = async () => {
      try {
        // eslint-disable-next-line no-unused-vars
        const [vendors, modifiers, packages] = await Promise.all([
          getAllBranch(),
          getAllZone(),
          getAllVendor(),
          getAllDriver(),
          getAllDropzone(),
        ]);
        // Handle the results here (e.g., set state)
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let branch = [];
    let zone = [];
    let timeSlot = [];
    let vendor = [];
    let driver = [];
    let dropzone = [];
    for (let item of allBranch)
      branch.push({
        name: item?.name,
        code: item?.id,
        isActive: false,
        address: item?.address,
      });
    for (let item of allZone)
      zone.push({
        name: item?.name,
        code: item?.id,
        isActive: false,
      });
    for (let item of timeSlots)
      timeSlot.push({
        name: item?.label,
        code: item?.value,
        isActive: false,
      });
    for (let item of allVendor)
      vendor.push({
        name: item?.name,
        code: item?.id,
        isActive: false,
      });
    for (let item of allDriver)
      driver.push({
        name: item?.name,
        code: item?.id,
        isActive: false,
      });
    for (let item of allDropzone)
      dropzone.push({
        name: item?.name,
        code: item?.id,
        isActive: false,
      });

    let dataSet = {
      timeSlot: timeSlot,
      orderType: [
        {
          name: "QC, Delivery & Payment",
          code: "qc-delivery-payment",
          isActive: false,
        },
        { name: "QC & Payment", code: "qc-payment", isActive: false },
        {
          name: "Delivery & Payment",
          code: "delivery-payment",
          isActive: false,
        },
        { name: "QC", code: "qc", isActive: false },
        { name: "Delivery", code: "delivery", isActive: false },
      ],
      status: [
        { name: "Initiated", code: "initiated", isActive: false },
        { name: "Not Initiated", code: "not-initiated", isActive: false },
        { name: "Approved", code: "approved", isActive: false },
      ],
      branch: branch,
      zone: zone,
      vendor: vendor,
      driver: driver,
      dropzone: dropzone,
    };
    setFilter(dataSet);
  }, [allBranch, allZone, allVendor, allDriver, allDropzone]);

  useEffect(() => {
    const orderNumberFromQuery = searchParams.get('order_number');

    const orderNumberFromState = location.state?.orderNumber;
    const activeTabFromState = location.state?.activeTab;

    const finalOrderNumber = orderNumberFromQuery || orderNumberFromState;
    const finalActiveTab = activeTabFromState || "1";

    if (finalOrderNumber) {
      setDefaultTabIndex(finalActiveTab);

      setInputData(prev => ({
        ...prev,
        order_number: finalOrderNumber
      }));
    }
  }, [searchParams, location.state?.orderNumber, location.state?.activeTab]);

  return (
    <>
      <Card className="res-tabs">
        <div className="flex justify-between mb-4 gap-5 items-center">
          <div className="flex items-center gap-4">
            <Typography className="text-xl font-semibold" align={"left"}>
              {t("orderManagement")}
            </Typography>
            <Switch
              checkedChildren="AR"
              unCheckedChildren="EN"
              checked={locale === "ar"}
              onChange={handleLanguageChange}
            />
          </div>
          {checkPermissionAction("Order Management", permissionJson, "bulk_upload") && defaultTabIndex === "1" && (
            <Button type="primary" onClick={() => setIsBulkUploadModalOpen(true)}>
              {t("bulkUpload")}
            </Button>
          )}
        </div>
        <div className="custom-tabs">
          <Tabs activeKey={defaultTabIndex} onChange={onTabChange} className="OrderManagement-tab">
            <Tabs.TabPane
              tab={
                <>
                  {t("newOrder")} <span>{parseInt(allCounts.pending_count) + parseInt(allCounts.approve_count)}</span>
                </>
              }
              key={1}
            >
              {defaultTabIndex === "1" && (
                <OrderListDetail
                  defaultTabIndex={defaultTabIndex}
                  allCounts={allCounts}
                  getAllOrdersCount={getAllOrdersCount}
                  permissionJson={permissionJson}
                  inputData={inputData}
                  setInputData={setInputData}
                  filter={filter}
                  setFilter={setFilter}
                />
              )}
            </Tabs.TabPane>
            <Tabs.TabPane tab={<>{t("preparing")} {<span>{allCounts.peparing_count}</span>}</>} key={2}>
              {defaultTabIndex === "2" && (
                <OrderListDetail
                  defaultTabIndex={defaultTabIndex}
                  getAllOrdersCount={getAllOrdersCount}
                  permissionJson={permissionJson}
                  inputData={inputData}
                  setInputData={setInputData}
                  filter={filter}
                  setFilter={setFilter}
                />
              )}
            </Tabs.TabPane>
            <Tabs.TabPane tab={<>{t("inReview")} {<span>{allCounts.in_review_count}</span>}</>} key={3}>
              {defaultTabIndex === "3" && (
                <OrderListDetail
                  defaultTabIndex={defaultTabIndex}
                  getAllOrdersCount={getAllOrdersCount}
                  permissionJson={permissionJson}
                  inputData={inputData}
                  setInputData={setInputData}
                  filter={filter}
                  setFilter={setFilter}
                />
              )}
            </Tabs.TabPane>
            <Tabs.TabPane tab={<>{t("readyToShip")} {<span>{allCounts.ready_to_ship_count}</span>}</>} key={4}>
              {defaultTabIndex === "4" && (
                <OrderListDetail
                  defaultTabIndex={defaultTabIndex}
                  getAllOrdersCount={getAllOrdersCount}
                  permissionJson={permissionJson}
                  inputData={inputData}
                  setInputData={setInputData}
                  filter={filter}
                  setFilter={setFilter}
                />
              )}
            </Tabs.TabPane>
            <Tabs.TabPane tab={<>{t("shipped")} {<span>{allCounts.shipped_count}</span>}</>} key={5}>
              {defaultTabIndex === "5" && (
                <OrderListDetail
                  defaultTabIndex={defaultTabIndex}
                  getAllOrdersCount={getAllOrdersCount}
                  permissionJson={permissionJson}
                  inputData={inputData}
                  setInputData={setInputData}
                  filter={filter}
                  setFilter={setFilter}
                />
              )}
            </Tabs.TabPane>
            <Tabs.TabPane tab={<>{t("readyToPickup")} {<span>{allCounts?.ready_to_pickup_count}</span>}</>} key={6}>
              {defaultTabIndex === "6" && (
                <OrderListDetail
                  defaultTabIndex={defaultTabIndex}
                  getAllOrdersCount={getAllOrdersCount}
                  permissionJson={permissionJson}
                  inputData={inputData}
                  setInputData={setInputData}
                  filter={filter}
                  setFilter={setFilter}
                />
              )}
            </Tabs.TabPane>
            <Tabs.TabPane
              tab={<>{t("completed")} {<span>{allCounts.completed_count}</span>}</>}
              key={9}
            >
              {defaultTabIndex === "9" && (
                <OrderListDetail
                  defaultTabIndex={defaultTabIndex}
                  getAllOrdersCount={getAllOrdersCount}
                  permissionJson={permissionJson}
                  inputData={inputData}
                  setInputData={setInputData}
                  filter={filter}
                  setFilter={setFilter}
                />
              )}
            </Tabs.TabPane>
            <Tabs.TabPane tab={<>{t("cancelled")} {<span>{allCounts.cancelled_count}</span>}</>} key={8}>
              {defaultTabIndex === "8" && (
                <OrderListDetail
                  defaultTabIndex={defaultTabIndex}
                  getAllOrdersCount={getAllOrdersCount}
                  permissionJson={permissionJson}
                  inputData={inputData}
                  setInputData={setInputData}
                  filter={filter}
                  setFilter={setFilter}
                />
              )}
            </Tabs.TabPane>

            <Tabs.TabPane tab={<>{t("noShow")} {<span>{allCounts.no_show_count}</span>}</>} key={7}>
              {defaultTabIndex === "7" && (
                <OrderListDetail
                  defaultTabIndex={defaultTabIndex}
                  getAllOrdersCount={getAllOrdersCount}
                  permissionJson={permissionJson}
                  inputData={inputData}
                  setInputData={setInputData}
                  filter={filter}
                  setFilter={setFilter}
                />
              )}
            </Tabs.TabPane>
          </Tabs>
        </div>
      </Card>
      {isBulkUploadModalOpen && (
        <BulkUploadModal
          isOpen={isBulkUploadModalOpen}
          onClose={() => setIsBulkUploadModalOpen(false)}
          reloadPage={() => {
            setInputData(prev => ({ ...prev, reloadKey: Date.now() }));
          }}
        />
      )}
    </>
  );
};
export default OrderManagement;
